"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationFailedForm = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var classnames_1 = __importDefault(require("classnames"));
var Copyright_1 = __importDefault(require("../../../components/Copyright"));
var AppSlogan_1 = __importDefault(require("../AppSlogan"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var VerificationFailedForm = function () {
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.page },
        react_1.default.createElement(AppSlogan_1.default, { title: t('APP_SLOGAN.TITLE'), text: t('APP_SLOGAN.TEXT'), backgroundType: "second", backgroundColor: "ternary" }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.form },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.content_body, styles_module_scss_1.default.failure) },
                    react_1.default.createElement("i", { className: "cm-icon icon-ic-warning" }),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.failure_text }, t('EMAIL_VERIFICATION_FAILED')),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.sub_title }, t('THE_ENTERED_LINK_IS_INCORRECT')),
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/' }, t('BACK'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.footer },
                    react_1.default.createElement(Copyright_1.default, null))))));
};
exports.VerificationFailedForm = VerificationFailedForm;
exports.default = exports.VerificationFailedForm;
